import { useRef } from "react";
import { BoxProps, Flex } from "@chakra-ui/react";
import { ExpandButton } from "src/components/common/expandable-tags/expand-button";
import { Tag } from "src/components/common/tag/tag";
import { useExpandableElements } from "src/hooks/dom/use-expandable-elements";
import { EnumTagColor } from "src/types/common-enum";

const DEFAULT_INITIAL_MAX_HEIGHT = 72;
interface IExpandableTags extends BoxProps {
    tags?: string[];
    initialMaxHeight?: number;
}

export const ExpandableTags = ({ tags, children, initialMaxHeight = DEFAULT_INITIAL_MAX_HEIGHT, ...boxProps }: IExpandableTags) => {
    const tagsRef = useRef<HTMLDivElement>(null);
    const { isExpandable, isExpanded, showAll } = useExpandableElements({ ref: tagsRef, maxHeight: DEFAULT_INITIAL_MAX_HEIGHT });

    return (
        <Flex
            ref={tagsRef}
            {...boxProps}
            rowGap={1}
            columnGap={2}
            flexWrap="wrap"
            pos="relative"
            overflow="hidden"
            transition="height 0.3s"
            maxHeight={!isExpanded ? `${initialMaxHeight}px` : "unset"}
        >
            {tags && tags.map(tag => <Tag key={tag} color={EnumTagColor.Gray} label={tag} pointerEvents="none" paddingX={1} />)}
            {children}
            {isExpandable && <ExpandButton onClick={showAll} />}
        </Flex>
    );
};
